import ReinsuredForm from 'components/features/reinsured-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function CreateReinsured() {
  const { t } = useTranslation();
  return (
    <HomeLayout title={t('reinsured.reinsuredRecords')}>
      <ReinsuredForm />
    </HomeLayout>
  );
}

export default CreateReinsured;
